<template>
  <section>
    <spinner v-if="loading"></spinner>
    <errors v-if="isVisibleErrorsModal"></errors>
    <!-- Page content-->
    <div class="content-wrapper">
        <div class="content-heading">
        Impact preferences
        </div>
    <!-- Preferences View -->
    <div class="panel panel-default">
        <SuccessAlert
          :isVisible="isSuccessMessageVisible"
          :message="successMessage"
          @hideSuccessAlert="hideSuccessMessage" />

        <header class="panel-title mt-xl mb-lg">
            <p>You can target your account balance to one or more portfolio sectors and
            initiatives below. We use this to inform our portfolio deployment and impact in line with investor interests. This is optional, and does not change the risk or any
            characteristics of your investments. Please refer to the
            <strong> <a target="_blank" href="https://www.calvertimpactcapital.org/prospectus">prospectus</a></strong> for more information.</p>
        </header>

        <div class="mb-lg">
           <preferences
              v-if="activeAccountId !== null"
              v-bind:account-id="activeAccountId"
              v-bind:primaryInvestor="user"
              v-on:saved="onPreferencesSaved"
              v-on:loaded="onPreferencesLoaded"
            ></preferences>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import Errors from '@/components/modals/Errors';
import preferences from '@/components/Preferences';
import SuccessAlert from '@/components/SuccessAlert';
import { Constants } from '@/data/static/constants';
import Spinner from '@/components/widgets/Spinner';

export default {
  data() {
    return {
      isSuccessMessageVisible: false,
      loading: true,
      successMessage: '',
      user: null,
    };
  },
  beforeMount() {
    this.initialize();
  },
  beforeDestroy() {
    this.hideSuccessMessage();
  },
  methods: {
    ...mapActions('accountCreation', ['getUserProfile']),
    async initialize() {
      await this.getUserProfile().then((user) => {
        this.user = Object.assign({}, user);
      });
    },
    onPreferencesSaved() {
      this.successMessage = Constants.investorPreferences.successMessage;
      this.isSuccessMessageVisible = true;
    },
    hideSuccessMessage() {
      this.isSuccessMessageVisible = false;
    },
    onPreferencesLoaded() {
      this.loading = false;
    },
  },
  computed: {
    ...mapState('errors', ['isVisibleErrorsModal']),
    ...mapState('app', ['activeAccountId']),
  },
  components: {
    errors: Errors,
    SuccessAlert,
    spinner: Spinner,
    preferences,
  },
};
</script>

<style scoped>
.panel-title {
  position: relative;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px dashed #eee;
}
form.row {
  padding: 0 15px;
}
strong {
  color: #23b7e5;
}
</style>




// WEBPACK FOOTER //
// InvestorPreferences.vue?f1ae4594